export default (node) => {
  const sizeSelectButtons = node.querySelectorAll('[data-size-selector]');
  const selectedSizeText = node.querySelector('[data-selected-size-text]');
  const outOfStockLabel = node.querySelector('[data-out-of-stock]');

  // Track selected texture for 3-option products
  let selectedTexture = null;
  let cachedAllVariants = [];

  /**
   * Functions
   */
  const changeSelectedSize = (button) => {
    const { size } = button.dataset;
    outOfStockLabel.classList.add('hidden');

    // Remove active class from all buttons
    sizeSelectButtons.forEach((button) => {
      button.classList.remove('size-selector--active');
    });

    // Add active class to the clicked button
    button.classList.add('size-selector--active');

    // Update the size text display
    updateSelectedSizeText(size);

    if (button.classList.contains('size-selector--sold-out')) {
      outOfStockLabel.classList.remove('hidden');
    }

    // Update add to cart button
    const eventUpdateButton = new CustomEvent(
      'add-to-cart:selected-size-change',
      {
        detail: { size: size },
      }
    );
    document.dispatchEvent(eventUpdateButton);

    // Update pair it with products
    document.dispatchEvent(
      new CustomEvent('pair-it-with:update-content', {
        detail: { size: size },
      })
    );

    // CASCADE DOWN (3-option products): Update color availability based on texture + size
    if (selectedTexture && cachedAllVariants.length > 0) {
      document.dispatchEvent(
        new CustomEvent('color-select:filter-by-texture-and-size', {
          detail: {
            texture: selectedTexture,
            size: size,
            allVariants: cachedAllVariants,
          },
        })
      );
    }
  };

  const updateSelectedSizeText = (size) => {
    selectedSizeText.innerHTML = size;
  };

  // EXISTING: 2-option product availability update (Color → Size cascade)
  const updateAvailability = (e) => {
    const { variantOptions } = e.detail;

    sizeSelectButtons.forEach((button) => {
      const { size } = button.dataset;
      const isAvailable = variantOptions.find(
        (element) => element.size.toUpperCase() === size.toUpperCase()
      );

      if (isAvailable && isAvailable.availability === 'true') {
        button.classList.remove('size-selector--sold-out');

        if (button.classList.contains('size-selector--active')) {
          outOfStockLabel.classList.add('hidden');
        }
      } else {
        button.classList.add('size-selector--sold-out');

        if (button.classList.contains('size-selector--active')) {
          outOfStockLabel.classList.remove('hidden');
        }
      }
    });
  };

  // NEW: 3-option product availability update (Texture → Size cascade)
  // Uses named keys: texture, size, color
  const filterByTexture = (e) => {
    const { texture, allVariants } = e.detail;
    selectedTexture = texture;
    cachedAllVariants = allVariants;

    // Update size button availability based on selected texture
    sizeSelectButtons.forEach((button) => {
      const { size } = button.dataset;
      const isAvailable = allVariants.some(
        (v) =>
          v.texture?.toUpperCase() === texture.toUpperCase() &&
          v.size?.toUpperCase() === size.toUpperCase() &&
          v.available
      );

      if (isAvailable) {
        button.classList.remove('size-selector--sold-out');

        if (button.classList.contains('size-selector--active')) {
          outOfStockLabel.classList.add('hidden');
        }
      } else {
        button.classList.add('size-selector--sold-out');

        if (button.classList.contains('size-selector--active')) {
          outOfStockLabel.classList.remove('hidden');
        }
      }
    });

    // CASCADE DOWN: Update color availability with current texture + current size
    const activeButton = node.querySelector('.size-selector--active');
    const currentSize = activeButton?.dataset.size;
    if (currentSize) {
      document.dispatchEvent(
        new CustomEvent('color-select:filter-by-texture-and-size', {
          detail: {
            texture,
            size: currentSize,
            allVariants,
          },
        })
      );
    }
  };

  const init = () => {
    sizeSelectButtons.forEach((button) => {
      button.addEventListener('click', () => changeSelectedSize(button));
    });

    // EXISTING: Listen for 2-option product color changes
    document.addEventListener(
      'size-select:update-availability',
      updateAvailability
    );

    // NEW: Listen for 3-option product texture changes
    document.addEventListener('size-select:filter-by-texture', filterByTexture);
  };

  /**
   * Init
   */
  init();
};
